import {Component, Input} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ValidationErrorTypes} from '../../validator/validation.helper';

@Component({
    selector: 'validation',
    styleUrls: ['./validation.component.scss'],
    templateUrl: './validation.component.html',
    standalone: false
})
export class ValidationComponent
{
    @Input({required: true}) formGroup: FormGroup<any>;
    @Input({required: true}) controlName: string;
    @Input({required: true}) displayName: string;

    constructor()
    {
    }

    get formGroupControls(): FormGroup['controls']
    {
        return this.formGroup.controls;
    }

    get shouldDisplayError(): boolean
    {
        const control = this.formGroupControls[this.controlName];
        if (control instanceof FormControl)
        {
            return ((control.touched || control.dirty) && !!control.errors);
        }
        return false;
    }

    get formControlErrorKeys()
    {
        return Object.keys(this.formGroupControls[this.controlName].errors) as ValidationErrorTypes[];
    }

    getValidationMessage(errorKey: ValidationErrorTypes): string
    {
        switch (errorKey)
        {
            case 'customValidation':
            case 'backendValidation':
                return this.formGroupControls[this.controlName].errors[errorKey];
            case 'required':
                return `${this.getControlNameForMessage()} is required`;
            case 'maxlength':
                return `${this.getControlNameForMessage()} is limited to a maximum length of `
                    + `${this.formGroupControls[this.controlName].errors[errorKey]?.requiredLength} characters`;
            case 'invalidMobileNumber':
                return `${this.getControlNameForMessage()} is invalid. Accepted formats: 0831234567, +27831234567, 27831234567`;
            case 'invalidIdLength':
                return `${this.getControlNameForMessage()} must be 13 characters and numeric`;
            case 'invalidIdNumber':
                return `${this.getControlNameForMessage()} must be a valid SA ID number`;
            case 'validateFSPNumber':
                return `${this.getControlNameForMessage()} must consist of digits from 0 to 9`;
            default:
                return `${this.getControlNameForMessage()} is invalid`;
        }
    }

    private getControlNameForMessage(): string
    {
        return this.displayName ?? this.controlName;
    }
}
